export const ALPHABETH = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const ROMAN = [
  "I",
  "II",
  "III",
  "IV",
  "V",
  "VI",
  "VII",
  "VIII",
  "IX",
  "X",
];

// Section A - Section U
export const MAX_SECTION = 21;
